import React, { Fragment } from 'react';

const accordions = [
  {
    title: 'Introduction and Instructions',
    content: (
      <Fragment>
        <p>
          Errors associated with injectable medications are more likely to result in death and morbidity than medications given through other routes. Risk of error is present with medication preparation and manipulation as well as administration. It is for that reason that The Joint Commission’s Medication Management standards direct that medications be dispensed in the most ready-to-administer (RTA) form as possible. Even with that goal in mind, the reality is that there are often barriers.
        </p>
        <p>
          This tracer tool has been designed to identify those barriers in order to tailor performance improvement efforts and achieve the goal of dispensing medications in the most ready-to-administer form possible.
        </p>
      </Fragment>
    ),
  }, {
    title: 'The Role of the Tracer',
    content: (
      <Fragment>
        <p>
          Tracer methodology, created by The Joint Commission, assesses the processes, communication, and coordination of the delivery of care in health care organizations. Tracer methodology is a powerful tool that uses observations, document review, and interviews to understand the current state of practices and identify opportunities for improvement.
        </p>
        <p>
          This tracer tool assesses how injectable medications are provided at various points of care and decision-making and identifies the factors that lead to either successful provision of medications in a ready-to-administer form or that prevent such administration. This tracer tool is designed to help hospitals in assessing the challenges and barriers and prioritizing and developing corrective action plans to improve the safety of injectable medications.
        </p>
      </Fragment>
    ),
  }, {
    title: 'Who Should Participate',
    content: (
      <ul>
        <li>
          The person(s) performing the tracers should be nonbiased, objective, and supportive to obtain honest feedback from staff. Because of the pharmacist’s influence in decisions relating to dispensing of injectable medications, pharmacy leadership should lead and actively participate in each tracer activity. Different clinicians and professionals may have unique perspectives with injectable medications, so nursing leadership, accreditation professionals, quality management/performance improvement professionals, safety officers, and others should also participate in the tracer activity.
        </li>
        <li>
          A scribe may be valuable in documenting tracer observations and responses that can then be analyzed to identify opportunities for improvement.
        </li>
        <li>
          To fully understand variance among practitioners, observe and interview several pharmacy staff, nurses, and anesthesia providers during the tracer activity. The tracer tool allows for one-on-one conversations as well as group discussions.
        </li>
      </ul>
    ),
  }, {
    title: 'Where to Conduct Tracers',
    content: (
      <ul>
        <li>
          This tracer activity includes targeted questions and observations for practices in the hospital pharmacy, nursing units (for example, medical/surgical, telemetry, critical care), emergency department, operating rooms, and procedural areas supported by anesthesia providers (for example, interventional radiology, gastroenterology procedures areas, cardiac catheterization procedure areas, ambulatory surgery, obstetrical operating rooms).
        </li>
        <li>
          To thoroughly assess injectable medication practices throughout the hospital, tracers should be conducted on multiple nursing units, operating rooms, and procedural areas to help identify patterns, trends, and variations in practices with injectable medications throughout the organization.
        </li>
      </ul>
    ),
  }, {
    title: 'Time Commitment',
    content: (
      <ul>
        <li>
          Each set of observations and questions asked of clinicians should take approximately 20 to 30 minutes. Interviews can be one-on-one discussions or group conversations.
        </li>
        <li>
          Many injectable medication practices change over time for varying reasons, including medication shortages. Therefore, use this tool periodically to reassess injectable medication processes and the impact of new barriers.
        </li>
      </ul>
    ),
  },
];

export default accordions;



// WEBPACK FOOTER //
// ./src/components/features/assessment/NewAssessmentAccordionsData.js